module.exports = __webpack_public_path__ + "img/heiTitle.3bb30eef.png";